import { Link } from 'react-router-dom';
import TimeUtils from '../../utils/TimeUtils';

interface PostProps {
  postId: number;
  postPath: string;
  thumbnail: string;
  title: string;
  desc: string;
  time: number;
}

const PostItem = ({
  postId,
  postPath,
  thumbnail,
  title,
  desc,
  time,
}: PostProps) => {
  return (
    <div className='sub-item my-11 w-full'>
      <Link className='sub-item-thumbnail' to={`${postPath}/${postId}`}>
        <img src={thumbnail} alt='Thumbnail' />
      </Link>
      <div className='sub-item-content py-6'>
        <div className='flex flex-col justify-between h-full'>
          <div className='block'>
            <Link
              className='title text-secondary text-xl font-medium mb-6'
              to={`${postPath}/${postId}`}
            >
              {title}
            </Link>
            <div className='desc text-secondary line-clamp-4'>{desc}</div>
          </div>
          <div className='flex flex-row justify-between'>
            <div className='date text-tertiary text-xs font-medium italic'>
              {TimeUtils.getDateDDMMYYYY(time)}
            </div>
            <Link
              className='view-more text-tertiary text-xs font-medium italic'
              to={`${postPath}/${postId}`}
            >
              Xem thêm
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostItem;
